import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 flex flex-col gap-4" }
const _hoisted_2 = { class: "flex flex-row gap-4 justify-between items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap items-center gap-4"
}
const _hoisted_4 = { class: "flex flex-col gap-3" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-1" }
const _hoisted_6 = {
  key: 1,
  class: "text-12px text-gray-lp-800 font-medium capitalize"
}
const _hoisted_7 = { class: "flex flex-row items-center gap-1" }
const _hoisted_8 = {
  key: 1,
  class: "text-16px text-black-lp-300 font-semibold"
}
const _hoisted_9 = {
  key: 3,
  class: "text-16px text-gray-lp-800 font-medium capitalize"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flew-row items-center gap-1"
}
const _hoisted_12 = { class: "text-24px text-black-lp-300 font-semibold" }
const _hoisted_13 = { class: "text-16px text-black-lp-300" }
const _hoisted_14 = {
  key: 3,
  class: "flex flew-row items-center gap-1"
}
const _hoisted_15 = { class: "rounded flex text-16px px-1 bg-orange-lp-100 text-orange-lp-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_DonutChart = _resolveComponent("DonutChart")!
  const _component_bullet_point = _resolveComponent("bullet-point")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_TooltipV2, {
            text: _ctx.data.title,
            fontSize: 14,
            fontWeight: "semibold"
          }, null, 8, ["text"])
        ]),
        (_ctx.data.detail?.length)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_skeleton, {
                    key: 0,
                    height: "5rem",
                    width: "8rem"
                  }))
                : (_ctx.data.data && _ctx.data.color)
                  ? (_openBlock(), _createBlock(_component_DonutChart, {
                      key: 1,
                      chartSeries: _ctx.seriesData,
                      chartColor: _ctx.data.color,
                      isShowTotal: "",
                      chartTitle: _ctx.$t('dexAssessmentConsolidator.ticketCount'),
                      chartHeight: "150",
                      chartWidth: "150"
                    }, null, 8, ["chartSeries", "chartColor", "chartTitle"]))
                  : _createCommentVNode("", true),
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.detail, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item,
                    class: "flex flex-col gap-1"
                  }, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_bullet_point, {
                        style: `color: ${item.color}`,
                        class: "w-2"
                      }, null, 8, ["style"]),
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_skeleton, {
                            key: 0,
                            height: "2rem",
                            width: "7rem"
                          }))
                        : (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$t(item.origin)), 1))
                    ]),
                    _createVNode("div", _hoisted_7, [
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_skeleton, {
                            key: 0,
                            height: "2rem",
                            width: "1.5rem"
                          }))
                        : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.formatDecimal(item.percentage.value)) + "% ", 1)),
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_skeleton, {
                            key: 2,
                            height: "2rem",
                            width: "2.5rem"
                          }))
                        : (_openBlock(), _createBlock("div", _hoisted_9, " (" + _toDisplayString(item.value) + " " + _toDisplayString(_ctx.$t("dexAssessmentConsolidator.ticketCount")) + ") ", 1))
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_10, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_skeleton, {
                    key: 0,
                    height: "2rem",
                    width: "8rem"
                  }))
                : (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDecimal(_ctx.data.total?.value)), 1),
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("dexAssessmentConsolidator.ticketCount")), 1)
                  ])),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_skeleton, {
                    key: 2,
                    height: "2rem",
                    width: "5rem"
                  }))
                : (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDecimal(_ctx.data.percentage?.value)) + "% ", 1)
                  ]))
            ]))
      ])
    ]),
    _: 1
  }))
}